import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=c3fe0d76&scoped=true&"
import script from "./sidebar.vue?vue&type=script&lang=js&"
export * from "./sidebar.vue?vue&type=script&lang=js&"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=c3fe0d76&prod&lang=scss&scoped=true&"
import style1 from "./sidebar.vue?vue&type=style&index=1&id=c3fe0d76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fe0d76",
  null
  
)

export default component.exports